import { getVariantsWithCache } from '../data/ARSCatalogData';

// Carica le varianti di un prodotto
export const fetchProductVariants = async (productId, list_variants = [], variantsCache, setVariants, lastExpandRequestRef, MIN_EXPAND_INTERVAL = 1000, setLoadingVariantsByProduct = null) => {
    try {
        // 🎯 NUOVO: Segna il prodotto come in caricamento
        if (setLoadingVariantsByProduct) {
            setLoadingVariantsByProduct(prev => ({
                ...prev,
                [productId]: true
            }));
        }

        // Verifica se è passato abbastanza tempo dall'ultima richiesta
        const now = Date.now();
        const timeSinceLastRequest = now - lastExpandRequestRef.current;

        // Se non è passato abbastanza tempo, attendi
        if (timeSinceLastRequest < MIN_EXPAND_INTERVAL) {
            await new Promise(resolve =>
                setTimeout(resolve, MIN_EXPAND_INTERVAL - timeSinceLastRequest)
            );
        }

        // Aggiorna il timestamp dell'ultima richiesta
        lastExpandRequestRef.current = Date.now();

        const productVariants = await getVariantsWithCache(productId, list_variants, variantsCache.current);

        // Memorizza nella cache
        variantsCache.current[productId] = productVariants;

        setVariants(prev => ({
            ...prev,
            [productId]: productVariants
        }));

        return productVariants;
    } catch (error) {
        console.error(`Error fetching variants for product ${productId}:`, error);
        throw error;
    } finally {
        // 🎯 NUOVO: Rimuovi il loading per questo prodotto
        if (setLoadingVariantsByProduct) {
            setLoadingVariantsByProduct(prev => {
                const newState = { ...prev };
                delete newState[productId];
                return newState;
            });
        }
    }
}; 